'use strict';

/**
 * Loads the content search results on the first click on the "Related content" tab.
 * The base handler is delegated on `.container`, but the tab lives in the search hero, outside any `.container`.
 */
module.exports = function () {
	$(document).on('click', '.content-search', function () {
		let $tab = $(this);
		let $target = $('#content-search-results');

		// inside a .container the base handler already does the job
		if ($tab.closest('.container').length || $target.html() !== '' || $tab.data('loading')) {
			return;
		}

		$tab.data('loading', true);
		$.spinner().start();
		$.ajax({
			url: $tab.data('url'),
			method: 'GET',
			success: function (response) {
				$target.append(response);
			},
			complete: function () {
				$tab.data('loading', false);
				$.spinner().stop();
			}
		});
	});
};
